import { render, staticRenderFns } from "./ModalSeleccionarCliente.vue?vue&type=template&id=3ec67de3&"
import script from "./ModalSeleccionarCliente.vue?vue&type=script&lang=js&"
export * from "./ModalSeleccionarCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports